import React, { useContext, useEffect, useState } from "react";
import { View } from "react-native";
import _ from "lodash";
import {
  Heading4,
  BasicText as Text,
  Heading2,
  ModalSubmitButton,
} from "../../Styles";
import { InputSelect, InputText, DatePicker, InputToggle } from "../../core";
import { Bound, useMagic } from "opidcore";
import { PortalDataContext } from "../../PortalContext";

import WasteBrand from "../../../WasteTheme";
import moment from "moment";
import Util from "../../core/Util";
import { MagicalState } from "../../core/MagicalState";

const ServiceRequest = ({ service = undefined, siteId = undefined }) => {
  const portalDataContext = useContext(PortalDataContext);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [siteOptions, setSiteOptions] = useState([]);
  const [contactInfo, setContactInfo] = useState(null);
  const [submitted, setSubmitted] = useState(null);
  const [contactInfoLabel, setContactInfoLabel] = useState("Email Address");

  const portalData = useContext(PortalDataContext);
  const myBoundMagic = useMagic({
    contactMethod: "email",
    contactMethodDetails: null,
    selectedService: service != null ? service.service_id : undefined,
    selectedSite: siteId || undefined,
    notes: undefined,
    pickupDate: null,
    asap: true,
  });

  useEffect(() => {
    if (portalData != undefined) {
      updateServiceOptions();

      setSiteOptions(
        _.map(_.uniqBy(portalData.sites, "site_id"), (s) => {
          return { value: s.site_id, label: s.name };
        })
      );
    }
  }, []);

  useEffect(() => {
    if (portalData.user != undefined && portalData.user.email != undefined) {
      myBoundMagic.magicalSet("contactMethodDetails", portalData.user.email);
      setContactInfo(portalData.user.email);
    }
  }, [portalData]);

  useEffect(() => {
    myBoundMagic.magicalState("selectedSite", updateServiceOptions);

    myBoundMagic.magicalState("contactMethod", (val) => {
      if (val == "email") {
        setContactInfoLabel("Email Address");
      } else {
        setContactInfoLabel("Phone #");
      }
    });
  }, [myBoundMagic]);

  const updateServiceOptions = (boundMagic, field, val) => {
    if (val != myBoundMagic.magicalGet("selectedSite") || val != undefined) {
      let filteredSite = undefined;

      if (siteId != undefined) {
        filteredSite = siteId;
      } else if (
        myBoundMagic.magicalGet("selectedSite") != undefined &&
        myBoundMagic.magicalGet("selectedSite") != ""
      ) {
        filteredSite = myBoundMagic.magicalGet("selectedSite");
      }

      if (filteredSite != undefined) {
        let services = [];
        if (filteredSite != undefined) {
          services = _.filter(portalData.services, {
            site: parseInt(filteredSite),
          });
        } else {
          services = portalData.services;
        }

        setServiceOptions(
          _.map(services, (s) => {
            return { value: s.service_id, label: s.service_name };
          })
        );
      }
    }
  };

  const submit = (e) => {
    e.stopPropagation();

    fetch(Util.getHost() + "/api/v1/portal/requestService", {
      method: "POST",
      headers: { portalUI: "yes" }, //portalUI header used in backend api authentication
      body: JSON.stringify({
        authToken: portalDataContext.authToken.code,
        pickup: {
          siteId: myBoundMagic.magicalGet("selectedSite"),
          serviceId: myBoundMagic.magicalGet("selectedService"),
          date: myBoundMagic.magicalGet("pickupDate"),
          notes: myBoundMagic.magicalGet("notes"),
          contactMethod: myBoundMagic.magicalGet("contactMethod"),
          contactMethodDetails: myBoundMagic.magicalGet("contactMethodDetails"),
          asap: myBoundMagic.magicalGet("asap"),
        },
      }),
    })
      .then((r) => {
        let content = null;

        if (r.ok == false) {
          content = r.text();
        }

        return content;
      })
      .then((error) => {
        let content = (
          <View>
            <Heading4>Request Submitted</Heading4>
            <Text>
              Look for an email from Waste Solutions with the appointment
              details.
            </Text>
          </View>
        );

        if (error != null) {
          content = (
            <View>
              <Heading4>Request Error</Heading4>
              <Text>{error}</Text>
            </View>
          );
        }

        setSubmitted(content);
      });
  };

  if (submitted != null) {
    return submitted;
  }

  const asapChanged = (value) => {
    if (value == true) {
      myBoundMagic.magicalSet("pickupDate", null);
    } else {
      if (
        myBoundMagic.magicalGet("pickupDate") == null ||
        myBoundMagic.magicalGet("pickupDate") == ""
      ) {
        myBoundMagic.magicalSet("pickupDate", moment().format("YYYY-MM-DD"));
      }
    }
  };

  const pickupDateChanged = (value) => {
    if (
      myBoundMagic.magicalGet("pickupDate") != null &&
      myBoundMagic.magicalGet("pickupDate") != ""
    ) {
      myBoundMagic.magicalSet("asap", false);
    }
  };

  return (
    <View>
      <Heading2 style={{ textAlign: "center" }}>Extra Pickup Request</Heading2>
      <View style={{ alignItems: "flex-start", zIndex: 1 }}>
        <Bound to={myBoundMagic}>
          <InputSelect
            field="selectedSite"
            label="Site"
            showEmpty={true}
            options={siteOptions}
            enabled={siteId == undefined}
            style={{ width: "100%", justifyContent: "space-between" }}
          />
          <InputSelect
            field="selectedService"
            label="Service"
            showEmpty={true}
            options={serviceOptions}
            style={{ width: "100%", justifyContent: "space-between" }}
          />
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              zIndex: 1,
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <InputToggle
              field="asap"
              label="ASAP"
              style={{ flexDirection: "row", alignItems: "center" }}
            />
            <MagicalState to="asap" setter={asapChanged} />
            <DatePicker
              field="pickupDate"
              label="Pickup Date"
              includeDateIntervals={[]}
            />
            <MagicalState to="pickupDate" setter={pickupDateChanged} />
          </View>
          <InputSelect
            field="contactMethod"
            label="Contact Via"
            options={[
              { value: "email", label: "Email" },
              { value: "phone", label: "Phone" },
            ]}
            style={{ width: "100%", justifyContent: "space-between" }}
          />
          <InputText
            field="contactMethodDetails"
            label={contactInfoLabel}
            defaultValue={contactInfo}
            outerStyle={{ width: "100%", justifyContent: "space-between" }}
          />
          <InputText
            field="notes"
            label="Notes"
            multiline={true}
            style={{ flexBasis: 70, minWidth: 300 }}
            outerStyle={{ width: "100%", justifyContent: "space-between" }}
          />
        </Bound>
      </View>
      <ModalSubmitButton onPress={submit} theme={WasteBrand}>
        Submit
      </ModalSubmitButton>
    </View>
  );
};

export default ServiceRequest;
